module.exports = {"420683001":"北城街道","420683002":"南城街道","420683003":"环城街道","420683100":"琚湾镇","420683101":"七方镇","420683102":"杨当镇","420683103":"太平镇","420683104":"新市镇","420683105":"鹿头镇","420683106":"刘升镇","420683107":"兴隆镇","420683108":"王城镇","420683109":"吴店镇","420683110":"熊集镇","420683111":"平林镇","420683402":"枣阳经济开发区","420683500":"随阳农场","420683501":"车河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420683.json
// module id = 1596
// module chunks = 0